/*
 * Sergio Rossi: season on product grid items (snippets/sr-product-season.liquid).
 * Hovering or focusing a color swatch shows that color's season, leaving the swatches restores it.
 * Same events as Motif's SiblingSwatches for the cutline (assets/theme.dev.js).
 */
(() => {
  if (customElements.get('sr-product-season')) return;

  class SrProductSeason extends HTMLElement {
    connectedCallback() {
      const holder = this.closest('[data-grid-item]')?.querySelector('[data-sibling-inner]');
      if (!holder) return;

      this.defaultValue = this.innerHTML;
      this.anySiblingSeason = this.dataset.anySiblingSeason === 'true';
      this.controller = new AbortController();
      const { signal } = this.controller;
      const isFocused = () => document.body.classList.contains('is-focused');

      holder.querySelectorAll('[data-sibling-season]').forEach((swatch) => {
        swatch.addEventListener('mouseenter', () => this.show(swatch.dataset.siblingSeason), { signal });
        swatch.addEventListener('focusin', () => isFocused() && this.show(swatch.dataset.siblingSeason), { signal });
      });

      holder.addEventListener('mouseleave', () => this.reset(), { signal });
      holder.addEventListener('focusout', () => isFocused() && this.reset(), { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
    }

    show(season) {
      if (season) {
        this.textContent = season;
      } else {
        // &nbsp; keeps the line when other colors have a season, preventing CLS
        this.innerHTML = this.anySiblingSeason ? '&nbsp;' : '';
      }
    }

    reset() {
      this.innerHTML = this.defaultValue;
    }
  }

  customElements.define('sr-product-season', SrProductSeason);
})();
